import {
  createTicketsScreenModel,
  type TicketsScreenProps,
} from './TicketsScreenModelScreen';
import { TicketsScreenController } from './TicketsScreenController';
import { TicketsScreenView } from './TicketsScreenView';
import { useInfoPopupState } from '../shared/infoPopup/infoPopupState';

export type { TicketsScreenProps } from './TicketsScreenModelScreen';

export function TicketsScreen(props: TicketsScreenProps) {
  const infoPopup = useInfoPopupState();
  const model = createTicketsScreenModel(props, infoPopup);
  const controller = new TicketsScreenController(model);

  return <TicketsScreenView model={model} controller={controller} />;
}
